import { render, staticRenderFns } from "./WaybillCaiWuRuLuRX.vue?vue&type=template&id=4a12420d&scoped=true&"
import script from "./WaybillCaiWuRuLuRX.vue?vue&type=script&lang=js&"
export * from "./WaybillCaiWuRuLuRX.vue?vue&type=script&lang=js&"
import style0 from "./WaybillCaiWuRuLuRX.vue?vue&type=style&index=0&id=4a12420d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12420d",
  null
  
)

export default component.exports